import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./chartSetup.js";
import App from "./App.jsx";
import "bootstrap/dist/css/bootstrap.min.css";
import { MaterialUIControllerProvider } from "./context/index.jsx";
import store from "./redux/store";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import WhatsAppFloatingIcon from "./WhatsAppFloatingIcon.jsx";

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "20px", color: "red" }}>
          <h1>Something went wrong.</h1>
          <pre>{this.state.error?.toString()}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

// Check if the container exists
const container = document.getElementById("root");
if (!container) {
  console.error("Failed to find the root element");
} else {
  try {
    const root = createRoot(container);
    root.render(
      <ErrorBoundary>
        <BrowserRouter>
          <MaterialUIControllerProvider>
            <Provider store={store}>
                <App />
                <WhatsAppFloatingIcon />
                <ToastContainer />
            </Provider>
          </MaterialUIControllerProvider>
        </BrowserRouter>
      </ErrorBoundary>
    );
  } catch (error) {
    console.error("Error rendering app:", error);
    document.getElementById("root").innerHTML = `
      <div style="padding: 20px; color: red;">
        <h1>Failed to render app</h1>
        <pre>${error.toString()}</pre>
      </div>
    `;
  }
}
